module.exports = __webpack_public_path__ + "media/images/real-runoland-ad8396bd716ddd0a54fc7a893305873c.png";